import { MenuEntity } from './components/entity';
import { MenuWrapper } from './internal/wrapper';

export * from './internal/selectionList';

export let Menu: typeof MenuWrapper & {
  Entity: typeof MenuEntity;
} = MenuWrapper as any;
Menu.Entity = MenuEntity;
